import * as Yup from 'yup';
const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

export const loginSchema = Yup.object({
    email: Yup.string().email().required('Please Enter your Email Address'),
    password: Yup.string()
        .min(8, 'Password must be at least 8 characters')
        .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
        .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
        .matches(/[0-9]/, 'Password must contain at least one number')
        .matches(/[!@#$%^&*(),.?":{}|<>]/, 'Password must contain at least one special character')
        .required('New Password is required'),
})

export const registerSchema = Yup.object({
    firstname: Yup.string().min(5).required('Please Enter First Name'),
    lastname: Yup.string().min(5).required('Please Enter Last Name'),
    email: Yup.string().email().required('Please Enter your Email Address'),
    mobile: Yup.string().matches(phoneRegExp, 'Mobile No. is not valid').required('Please Enter your Mobile No.'),
    password: Yup.string()
        .min(8, 'Password must be at least 8 characters')
        .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
        .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
        .matches(/[0-9]/, 'Password must contain at least one number')
        .matches(/[!@#$%^&*(),.?":{}|<>]/, 'Password must contain at least one special character')
        .required('New Password is required'),
    confirmpassword: Yup.string()
        .oneOf([Yup.ref('password'), null], 'Passwords must match')
        .required('Confirm Password is required'),
})

export const forgotPasswordSchema = Yup.object({
    email: Yup.string().email().required('Please Enter your Email Address'),
})

export const changResPaaSchema = Yup.object({
    password: Yup.string()
        .min(8, 'Password must be at least 8 characters')
        .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
        .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
        .matches(/[0-9]/, 'Password must contain at least one number')
        .matches(/[!@#$%^&*(),.?":{}|<>]/, 'Password must contain at least one special character')
        .required('New Password is required'),

    confirmpassword: Yup.string()
        .oneOf([Yup.ref('password'), null], 'Passwords must match')
        .required('Confirm Password is required'),
})

export const addressSchema = Yup.object({
    firstName: Yup.string().min(3).required('Please Enter First Name'),
    lastName: Yup.string().min(3).required('Please Enter Last Name'),
    addressLine1: Yup.string().min(10).required('Please Enter addressLine1'),
    addressLine2: Yup.string(),
    landmark: Yup.string(),
    state: Yup.string().required('Please Enter State'),
    city: Yup.string().required('Please Select City'),
    postalCode: Yup.string()
        .matches(/^\d{6}$/, 'postal Code must be exactly 6 digits')
        .required('postal Code is required'),
    mobile: Yup.string().matches(/^[0-9]{10}$/, 'Mobile number must be exactly 10 digits')
        .required('Mobile number is required'),
})

export const couponCodeSchema = Yup.object({
    code: Yup.string().min(3, 'Coupon Code must be at least 3 characters').required('Please Enter Coupon Code'),
})

export const RatingsSchema = Yup.object({
    rating: Yup.number().min(0.5, "Please select a rating").required("Rating is required"),
    message: Yup.string().required("Message is required"),
})

export const ReplacementSchema = Yup.object({
    warrantyNumber: Yup.string().required("Warranty Number is required"),
})

const profileSchema = (otpRequested) =>
    Yup.object().shape({
        firstName: Yup.string(),
        lastName: Yup.string(),
        gender: Yup.string(),
        dob: Yup.string(),
        email: Yup.string().email(),
        mobile: Yup.string().matches(/^[0-9]{10}$/, 'Mobile number must be exactly 10 digits')
            .required('Mobile number is required'),
        otp: Yup.string(),
    });

export { profileSchema };

const loginsSchema = (isOtp) =>
    Yup.object().shape({
        mobile: Yup.string().matches(/^[0-9]{10}$/, 'Mobile number must be exactly 10 digits')
            .required('Mobile number is required'),
        otp: Yup.string()
    });

export { loginsSchema };